import { Model, Attr, HasOne } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';
import { Lot } from './';

@Model()
export default class LotRegion extends ApplicationRecord {
  static jsonapiType = 'lot-regions';

  static listHeaders() {
    return [
      {
        text: 'ID',
        value: 'id',
        width: 100,
        sortable: false,
      },
      {
        text: 'Name',
        value: 'name',
      },
      {
        text: 'Rows',
        value: 'rows',
      },
    ];
  }

  static scopeFactory() {
    return LotRegion.includes([]);
  }

  @Attr() name: string;
  @Attr() rows: number;

  @HasOne() lot: Lot;
}
